<template>
	<div style="background-color: #fcfcfc;">
		<div style="background-color: #fff;position: fixed;width: 100%;box-shadow: 0in 2.25pt 3.75pt;transition: opacity 2s ease-in;transform-style: preserve-3d;z-index: 99999;">
			<Myheaderesa></Myheaderesa>
		</div>
		<div style="height: 60px;"></div>
		<div class="course" style="margin-bottom: 60px;">
			<div style="width: 100%;margin-bottom: 30px;overflow: hidden;"><img style="width: 100%;" src="@/images/banner_x_2.png" alt="" /></div>
			<div class="courseli">
				<div class="fliters fleys">
					<ul class="flexs " style="align-items: flex-start;">
						<li class="fliterstitle">专业</li>
						<li class="flexs" style="align-items: flex-start;width: 88%;">
							<div class="flexs" ref="changeszy" :style="{ height: iszymore ? 'auto' : '40px' }" style="width: 98%; flex-wrap: wrap; height: 40px; overflow: hidden;">
								<li
									style="margin-top: 5px;"
									:class="{ choiceactive: zyguid == '' }"
									@click="
										zyguid = '';
										getpositionlists();
										getresourceList();
									"
								>
									全部
								</li>
								<li style="margin-top:5px;" v-for="(item, index) in zylist" :key="index" @click="changezy(item)" :class="{ choiceactive: item.pro_guid == zyguid }">
									{{ item.pro_name }}
								</li>
							</div>
						</li>
						<div class="morebtn" style="margin-left: auto;" @click="changemore(1)"><i class="el-icon-arrow-down"></i></div>
					</ul>
					<ul class="flexs" style="flex-wrap: wrap;align-items: flex-start;">
						<li class="fliterstitle">岗位</li>
						<li class="flexs" style="align-items: cenetr;width: 88%;">
							<div class="flexs" ref="changesgw" :style="{ height: isgwmore ? 'auto' : '40px' }" style="flex-wrap: wrap;height: 40px;overflow: hidden;">
								<li
									:class="{ choiceactive: gwguid == '' }"
									@click="
										gwguid = '';
										getresourceList();
									"
								>
									全部
								</li>
								<li
									v-for="(item, index) in gwlist"
									:key="index"
									@click="
										gwguid = item.PR_GUID;
										getresourceList();
									"
									:class="{ choiceactive: gwguid == item.PR_GUID }"
								>
									{{ item.PR_ProfessionalName }}
								</li>
							</div>
						</li>
						<div class="morebtn" style="margin-left: auto;margin-top: 8px;" @click="changemore(2)"><i class="el-icon-arrow-down"></i></div>
					</ul>
					<ul class="flexs" style="flex-wrap: wrap;">
						<li class="fliterstitle">类型</li>
						<li
							style="margin-left: 15px;"
							:class="{ choiceactive: lxguid == '' }"
							@click="
								lxguid = '';
								getresourceList();
							"
						>
							全部
						</li>
						<li
							v-for="(item, index) in lxlist"
							:key="index"
							@click="
								lxguid = item.RT_GUID;
								getresourceList();
							"
							:class="{ choiceactive: lxguid == item.RT_GUID }"
						>
							{{ item.RT_ResourceTitle }}
						</li>
					</ul>
				</div>
				<div class="fliterschoice flexs" style="height: 60px;line-height: 60px;">
					<div class="flexs">
						<p class="titlesactive">默认排序</p>
						<p>发布时间</p>
						<p>热度</p>
						<p>课时</p>
						<p>未授权</p>
						<p>授权</p>
						<!-- <el-input style="width: 200px;" class="custom-input" placeholder="输入关键词搜索" suffix-icon="el-icon-search" v-model="input1"></el-input> -->
						<!-- <input style="width: 200px;border: 1px solid #ccc;padding: 10px;background-color: #fcfcfc;border-radius: 20px;" v-model="input1" type="text" placeholder="输入关键词搜索" /> -->
					</div>
					<div style="font-size: 15px;font-weight: 600;">
						找到
						<span style="color: red;">{{ resourcetotle }}</span>
						个素材
					</div>
				</div>
				<div style="height: 20px;line-height: 20px;border-top:1px solid #ccc;"></div>
				<!-- <el-divider></el-divider> -->
				<div class="courselist flexs">
					<el-empty style="width: 100%;" v-if="resourcelist.length == 0" description="暂无资源"></el-empty>
					<div class="courseitem" v-for="(item, index) in resourcelist" :key="item.LR_GUID" @click="goresource(item)">
						<div style="overflow: hidden;">
							<img style="height: 160px;" :src="item.LR_SurfacePlotUrl ?? 'https://www.hngtsd.net:65535/appstatic/images/ykc1.png'" alt="" />
						</div>
						<div class="courseitems">
							<p class="coursefonts">{{ item.LR_Title }}</p>
							<p style="margin-top: 10px;">
								文件大小：
								<span>{{ formatSize(item.LR_FileSize) }}</span>
							</p>
							<div class="flexs courseitemstudy" style="margin-bottom: 0;">
								<p>
									文件类型：
									<span>{{ item.RT_ResourceTitle }}</span>
								</p>
								<!-- <p style="color: red;">未授权</p> -->
							</div>
						</div>
					</div>
				</div>
				<div style="padding: 20px 0;width: 50%;margin: auto;">
					<el-pagination
						background
						hide-on-single-page
						layout="prev, pager, next,total"
						prev-text="上一页"
						next-text="下一页"
						:page-size="coureseobj.pageSize"
						:current-page="coureseobj.pageIndex"
						:total="resourcetotle"
						@current-change="changecurr"
					></el-pagination>
				</div>
			</div>
		</div>
		<div style="margin-top: 10px;"><Myfooters></Myfooters></div>
	</div>
</template>
<script>
import AppOptions from '../config/AppOptions.vue';

import Myheaderesa from '@/components/layout/headeresa.vue';

import Myfooters from '@/components/layout/footers.vue';

import { getGetProfList, getPositionList, getGetResourceType, getGetPagResourceList } from '@/request/api/homesview/yunhomes/yunhom.js';

export default {
	components: {
		Myheaderesa,
		Myfooters
	},
	data() {
		return {
			input1: '',
			input1: '',
			zyguid: '',
			zylist: [],
			gwguid: '',
			gwlist: [],
			lxguid: '',
			lxlist: [],
			coureseobj: {
				pageSize: 8,
				pageIndex: 1,
				RT_GUID: '',
				ProfessionalID: '',
				PR_GUID: '',
				ResourceName: '',
				si_guid: ''
			},
			resourcelist: [],
			resourcetotle: 0,
			iszymore: true,
			isgwmore: true
		};
	},
	created() {
		AppOptions.appEmpty = true;
	},
	// beforeRouteLeave(to, from, next) {
	// 	AppOptions.appEmpty = false;
	// 	next();
	// },
	mounted() {
		this.init();
	},

	methods: {
		changemore(num) {
			// console.log(this.$refs.changeszy.style)
			if (num == 1) {
				// if (this.iszymore) {
				// 	this.$refs.changeszy.style.height = 'auto';
				// } else {
				// 	this.$refs.changeszy.style.height = '40px';
				// }
				this.iszymore = !this.iszymore;
			} else if (num == 2) {
				// if (this.isgwmore) {
				// 	this.$refs.changesgw.style.height = 'auto';
				// } else {
				// 	this.$refs.changesgw.style.height = '40px';
				// }
				this.isgwmore = !this.isgwmore;
			}
		},
		changecurr(val) {
			this.coureseobj.pageIndex = val;
			this.getresourceList();
		},

		formatSize(bytes) {
			let units = ['KB', 'MB', 'GB', 'TB'];

			if (bytes < 1024) {
				return bytes + ' ' + units[0];
			} else if (bytes < 1024 * 1024) {
				return (bytes / 1024).toFixed(2) + ' ' + units[1];
			} else if (bytes < 1024 * 1024 * 1024) {
				return (bytes / (1024 * 1024)).toFixed(2) + ' ' + units[2];
			} else if (bytes < 1024 * 1024 * 1024 * 1024) {
				return (bytes / (1024 * 1024 * 1024)).toFixed(2) + ' ' + units[3];
			} else {
				return (bytes / (1024 * 1024 * 1024 * 1024)).toFixed(2) + ' ' + units[4];
			}
		},
		goresource(item) {
			let size = this.formatSize(item.LR_FileSize);
			if (localStorage.getItem('usercenter')) {
				this.$router.push('/resource/resourcedetils?liguid=' + item.LR_GUID + '&size=' + size);
			} else {
				this.$router.push('/user/logins?liguid=' + item.LR_GUID + '&size=' + size + '&typepath=2');
			}
		},
		init() {
			this.getprolist();
			this.getresourcetype();
			this.getresourceList();
		},
		getresourceList() {
			this.coureseobj.ProfessionalID = this.zyguid;
			this.coureseobj.PR_GUID = this.gwguid;
			this.coureseobj.RT_GUID = this.lxguid;
			getGetPagResourceList(this.coureseobj).then(res => {
				if (res.data && res.data.data) {
					this.resourcelist = res.data.data.list;
					this.resourcetotle = res.data.data.totalCount;
				}
			});
		},
		gocoudetea() {
			this.$router.push('/cours/clouddetea');
		},
		// 专业
		getprolist() {
			getGetProfList().then(res => {
				this.zylist = res.data.data;
				this.getpositionlists();
			});
		},
		changezy(itm) {
			this.zyguid = itm.pro_guid;
			this.gwguid = '';
			this.getpositionlists();
			this.getresourceList();
		},
		// 岗位
		getpositionlists() {
			var pro_guid = this.zyguid;
			getPositionList(pro_guid).then(res => {
				this.gwlist = res.data.data;
			});
		},
		// 等级
		getresourcetype() {
			getGetResourceType().then(res => {
				this.lxlist = res.data.data;
			});
		}
	}
};
</script>

<style scoped lang="less">
.morebtn {
	color: #333;
	// border: 1px solid #ddd;
	margin-right: 10px;
	position: absolute;
	right: 0;
	width: 50px;
	height: 23px;
	line-height: 23px;
	padding: 0 7px 0 4px;
	background: #fff;
	margin-top: 8px;
	font-size: 16px;
	cursor: pointer;
	text-align: right;
}

.morebtn:hover {
	i {
		color: #0054ff;
	}
}

.custom-input {
	z-index: 10 !important;
}

.choiceactive {
	padding: 0 20px;
	border: 1px solid #0054ff;
	border-radius: 30px;
	background: #0054ff;
	color: #fff;
}

/deep/ .el-input {
	height: 30px;

	input {
		height: 100%;
	}

	.el-input__suffix {
		display: flex;
		justify-content: center;
		align-items: center;
	}
}

.fliterschoice {
	justify-content: space-between;
	p {
		margin: 0 10px;
		cursor: pointer;
		font-size: 16px;
	}
	.titlesactive {
		color: #0054ff;
		font-weight: 700;
	}
}

/deep/ .el-divider--horizontal {
	margin: 15px 0;
}

.course {
	// height: 100vh;
}

.flexs {
	display: flex;
	align-items: center;
}

.fleys {
	display: flex;
	flex-direction: column;
}

.fliters {
	background: #fff;
	padding: 10px;
	border-radius: 10px;
	font-size: 16px;
	box-shadow: 0px 0px 5px 0px #ccc;
	margin: 40px 0;
	position: relative;
	ul {
		padding: 10px 0;
		border-bottom: 1px dashed #ccc;
		li {
			margin: 4px 10px;
			cursor: pointer;
		}
		li:first-child {
			margin-left: 5px;
		}
	}
	ul:last-child {
		border-bottom: none;
	}

	.fliterstitle {
		font-size: 18px;
		color: #000;
		margin-right: 5px;
		margin-top: 8px;
		width: 50px;
	}
}

/deep/ .el-pagination {
	display: flex;
	justify-content: center;
	align-items: center;
}

.courseitems {
	padding: 10px;
	background-color: #f5f5f5;
	height: 110px;
}

.courseli {
	min-width: 1200px;
	width: 1200px;
	margin: auto;
}

.coursefonts {
	font-size: 14px;
	color: #373c41;
	font-weight: 600;
}

.courselist {
	flex-wrap: wrap;

	.courseitemstudy {
		justify-content: space-between;
		margin: 10px 0;
	}

	.courseitem {
		width: 24%;
		margin-right: 1%;
		border: 1px solid #ccc;
		border-radius: 4px;
		margin-bottom: 40px;
		overflow: hidden;
		height: 260px;
		z-index: 2;
		transform-style: preserve-3d;

		img {
			width: 100%;
		}
		img:hover {
			transform: scale(1.2);
			transition: all 2s;
			overflow: hidden;
		}
	}
}
</style>
